// extracted by mini-css-extract-plugin
export default {"field-label":"FieldLabel_field-label__7-MXB"};